export default {
  name: 'prod',
  whatsAppApiUrl: process.env.REACT_APP_WHATS_APP_API_URL || 'https://web.whatsapp.com/send?',
  herbieApiHost: process.env.REACT_APP_HERBIE_API_HOST || 'https://api.cobli.co/herbie-1.1',
  apiHost: process.env.REACT_APP_API_HOST || 'https://api.cobli.co',
  apiV2: process.env.REACT_APP_API_V2 || 'https://api.cobli.co/v2',
  experience: process.env.REACT_APP_EXPERIENCE || 'https://api.cobli.co/public/',
  segmentAnalyticsKey: process.env.REACT_APP_SEGMENT_ANALYTICS_KEY || 'yCSPHrYg0EPU9qhJM8RxUEM0onUpzcHl',
  googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || 'AIzaSyDhGp8Wx17GWE4XHW8n1IGNi2RbUVYmGFY',
  cobliInviteUrl: process.env.REACT_APP_COBLI_INVITE_URL || 'https://cadastro.cobli.co/invites',
  graphqlHost: process.env.REACT_APP_GRAPHQL_HOST || 'https://api.cobli.co/graphql',
  oneSignalAppId: process.env.REACT_APP_ONE_SIGNAL_APP_ID || '4dbf5aaa-e65d-46fd-8adf-76ec5bfb7e33',
  ddRUMapplicationId: process.env.REACT_APP_DD_RUM_APPLICATION_ID || '60cdf473-9458-40a8-9dea-b7afa2780fef',
  ddRUMclientToken: process.env.REACT_APP_DD_RUM_CLIENT_TOKEN || 'pub29a278593a96327964c248285a4d7737',
  cerberusHost: process.env.REACT_APP_CERBERUS_HOST || 'https://api.cobli.co/api-keys',
  launchDarklyId: process.env.REACT_APP_LAUNCH_DARKLY_ID || '5b5754656c774e2ec9e8f028',
  clarityId: process.env.REACT_APP_CLARITY_ID || 'ggup71sx0n',
  geofenceApiHost: process.env.REACT_APP_GEOFENCE_API_HOST || 'https://api.cobli.co/v3/geofences',
  alertsApiHost: process.env.REACT_APP_ALERTS_API_HOST || 'https://api.cobli.co/v1/triggers',
  blueprintApiHost: process.env.REACT_APP_BLUEPRINT_API_HOST || 'https://api.cobli.co/blueprint',
  apiEfopBusinessManager: process.env.REACT_APP_API_EFOP_BUSINESS_MANAGER || 'https://api.cobli.co/erp/sm',
  apiEfopCustomerTickets: process.env.REACT_APP_API_EFOP_CUSTOMER_TICKETS || 'https://api.cobli.co/crm/sm',
  brasilApiHost: process.env.REACT_APP_BRASIL_API_HOST || 'https://brasilapi.com.br/api/',
  googleMapsVectorKey: process.env.REACT_APP_GOOGLE_MAPS_VECTOR_KEY || 'AIzaSyDuhwkeLD1NXIgH2GJGNpKh1AYSt_r16VU',
  mastraApi: process.env.REACT_APP_MASTRA_API || 'https://api.cobli.co/ai',
  prismicRepositoryDashboard: process.env.REACT_APP_PRISMIC_REPOSITORY_DASHBOARD || 'herbie-dashboard',
  prismicRepositoryNeoMidas: process.env.REACT_APP_PRISMIC_REPOSITORY_NEO_MIDAS || 'neo-midas',
  prismicRepositorySupport: process.env.REACT_APP_PRISMIC_REPOSITORY_SUPPORT || 'support-cobli',
  posthogToken: process.env.REACT_APP_POSTHOG_TOKEN || 'phc_nB6pZvZXoxYgcS6DkeoecghYw4XyQ5NyYMgnaRLJ3yQB',
  posthogHost: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  cognito: {
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_hx5BboneW',
    userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || '9ptbgha1mbmfq6o5do7ra23qh',
  },
};
